module.exports = __webpack_public_path__ + "assets/images/pick-up.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/pick-up.png
// module id = 405
// module chunks = 1